
import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Share } from "lucide-react";
import { useResourceInvitations } from "./hooks/useResourceInvitations";
import { InvitationList } from "./InvitationList";
import { InvitationForm } from "./InvitationForm";

interface ShareResourceDialogProps {
  resourceId: string;
  topic: string;
  company: string;
  previewImageUrl?: string | null;
}

export function ShareResourceDialog({
  resourceId,
  topic,
  company,
  previewImageUrl
}: ShareResourceDialogProps) {
  const [isOpen, setIsOpen] = useState(false);
  
  const {
    existingInvites,
    fetchExistingInvites,
    handleRevokeInvite,
    handleDownloadCertificate
  } = useResourceInvitations(resourceId, isOpen);

  // We need to create a wrapper for certificate download to include the topic
  const downloadCertificate = async (email: string) => {
    await handleDownloadCertificate(email);
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" className="w-full">
          <Share className="mr-2 h-4 w-4" />
          Share with Trainees
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Share Training Resource</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div>
            <p className="text-sm font-medium mb-4">
              Share "{topic}" from {company} with trainees
            </p>
            
            <InvitationList 
              invitations={existingInvites} 
              onRevokeInvite={handleRevokeInvite} 
              onDownloadCertificate={downloadCertificate}
            />
            
            <InvitationForm
              resourceId={resourceId}
              topic={topic}
              company={company}
              onInvitationsSent={fetchExistingInvites}
              onClose={() => setIsOpen(false)}
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
